/**
 * @typedef {import("../../types/directus").components["schemas"]["ItemsStats"]} DirectusStats
 * @typedef {import("../../types/directus").components["schemas"]["x-metadata"]} DirectusMeta
 */
import { useQuery } from "@tanstack/react-query";
import { getJson } from "../client";

export function useStats({ showOnHomepage = false, options = {} } = {}) {
  const queryKey = [
    "stats",
    {
      showOnHomepage: showOnHomepage || "all",
    },
  ];

  return useQuery({
    queryKey,
    /** @returns {Promise<{ data?: DirectusStats[]; meta?: DirectusMeta }>} */
    queryFn: async () => {
      const fields = [
        "id",
        "value",
        "icon",
        "Show_on_homepage",
        "translations.id",
        "translations.name",
        "translations.languages_code",
      ].join(",");

      const params = {
        fields,
        sort: "id",
        limit: "100", // Get all stats
      };

      // Add filter for homepage stats if requested
      if (showOnHomepage) {
        params.filter = JSON.stringify({
          Show_on_homepage: { _eq: true },
        });
      }

      const json = await getJson("/items/stats", params);
      return json; // { data, meta }
    },
    staleTime: 300_000, // 5 minutes
    refetchOnWindowFocus: false,
    ...options,
  });
}

export default useStats;
